
export default {
  name: 'PagePaddockSingle',

  head() {
    return {
      title: `Paw Paddock ${this.compPaddock.name}`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.compPaddock?.description?.substring(0, 155)
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content:
            this.compPaddock.featuredImage && this.compPaddock.featuredImage.length > 0
              ? `${this.compPaddock.featuredImage[0].publicUrl}?height=600&width=1200&trim=${this.compPaddock.imageCropTop};${this.compPaddock.imageCropRight};${this.compPaddock.imageCropBottom};${this.compPaddock.imageCropLeft}`
              : 'https://assets.pawpaddock.co.uk/assets/images/app/og.jpg'
        }
      ],

      script: this.compStructuredData
        ? [{ hid: 'ld-json', type: 'application/ld+json', json: this.compStructuredData }]
        : []
    }
  },

  computed: {
    // Machine-readable summary for search engines and AI assistants (schema.org)
    compStructuredData() {
      const paddock = this.compPaddock

      if (!paddock.id) {
        return null
      }

      const origin = process.env.DASHBOARD_URL
      const facilities = (paddock.facilities || '').split(',')
      const facilityLabels = {
        water: 'Running water',
        agility: 'Agility obstacles',
        paths: 'Solid paths',
        shelter: 'Field shelter'
      }

      const amenities = Object.keys(facilityLabels)
        .filter(key => facilities.includes(key))
        .map(key => facilityLabels[key])

      if (paddock.hasDogWash) {
        amenities.push('Dog wash')
      }

      return {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        '@id': `${origin}/paddocks/${paddock.slug}`,
        name: `Paw Paddock ${paddock.name}`,
        description: paddock.description,
        url: `${origin}/paddocks/${paddock.slug}`,
        image: paddock.featuredImage?.[0]?.publicUrl,
        currenciesAccepted: 'GBP',
        priceRange: '£',
        address: {
          '@type': 'PostalAddress',
          streetAddress: [paddock.addressLine1, paddock.addressLine2].filter(Boolean).join(', '),
          addressLocality: paddock.addressLocality,
          addressRegion: paddock.addressRegion,
          postalCode: paddock.addressCode,
          addressCountry: 'GB'
        },

        geo:
          paddock.entranceCoordinatesLat && paddock.entranceCoordinatesLng
            ? {
                '@type': 'GeoCoordinates',
                latitude: paddock.entranceCoordinatesLat,
                longitude: paddock.entranceCoordinatesLng
              }
            : undefined,

        amenityFeature: amenities.map(name => ({
          '@type': 'LocationFeatureSpecification',
          name,
          value: true
        })),

        makesOffer: [25, 55].map(length => ({
          '@type': 'Offer',
          name: `${length} minute private field hire`,
          price: (paddock[`price${length}`] / 100).toFixed(2),
          priceCurrency: 'GBP',
          availability: 'https://schema.org/InStock',
          url: `${origin}/book/${paddock.slug}?length=${length}`
        })),

        potentialAction: {
          '@type': 'ReserveAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${origin}/book/${paddock.slug}`,
            actionPlatform: ['https://schema.org/DesktopWebPlatform', 'https://schema.org/MobileWebPlatform']
          },

          result: { '@type': 'Reservation', name: 'Paddock session' }
        }
      }
    },

    compHero() {
      return {
        image:
          this.compPaddock.featuredImage && this.compPaddock.featuredImage.length > 0
            ? `${this.compPaddock.featuredImage[0].publicUrl}?height=400&width=1700&trim=${this.compPaddock.imageCropTop};${this.compPaddock.imageCropRight};${this.compPaddock.imageCropBottom};${this.compPaddock.imageCropLeft}`
            : require('~/assets/images/backgrounds/paddocks-hero-2.jpg'),

        alt: 'Dog in Paw Paddock'
      }
    },

    compPaddock() {
      return this.$store.getters['paddocks/paddockBySlug'](this.$route.params.slug) || {}
    }
  },

  created() {
    if (this.$app.isNative) {
      this.$redirect.to(`/platform/paddocks/${this.$route.params.slug}`)
    }
  },

  methods: {
    onFindOutMore(paddock) {
      this.$redirect.to(`/paddocks/${paddock.slug}`)
    },

    onViewAll() {
      this.$redirect.to(`/paddocks`)
    },

    onBook(paddock) {
      this.$redirect.to(`/book/${paddock.slug}`)
    }
  }
}
